module.exports = __webpack_public_path__ + "img/webeditor-7.4a825893.png";